import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';
import {AsyncState, RejectedState} from '../../models/async_state';
import {Status} from '../../enums/status';
import {FailureIndicatorsQuery} from '../../gql/pwa/graphql.ts';
import {FailureIndicators} from '../../network/failure_indicators.ts';

interface State extends FailureIndicatorsQuery {}

export const fetchIndicators = createAsyncThunk(
    'failureIndicators/fetchIndicators',
    async (data: {brand: string | null}) => {
        const result = await FailureIndicators.getIndicators(data.brand);
        return result.data;
    },
);

export const failureIndicatorSlice = createSlice({
    name: 'failureIndicators',
    initialState: () => {
        const initialState: AsyncState<State> = {
            status: Status.IDLE,
        };
        return initialState as AsyncState<State>;
    },
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(fetchIndicators.pending, (state) => {
            state.status = Status.PENDING;
        });
        builder.addCase(fetchIndicators.fulfilled, (state, action) => {
            state.status = Status.FULFILLED;
            state.failureIndicators = action.payload.failureIndicators;
            state.__typename = action.payload.__typename;
        });
        builder.addCase(fetchIndicators.rejected, (state, action) => {
            state.status = Status.REJECTED;
            (state as RejectedState<State>).error = action.error.message ?? 'Error';
        });
    },
});
